import { render } from "./ServiceDetails6.vue?vue&type=template&id=e9dfc8a6&scoped=true"
import script from "./ServiceDetails6.vue?vue&type=script&lang=js"
export * from "./ServiceDetails6.vue?vue&type=script&lang=js"

import "./ServiceDetails6.vue?vue&type=style&index=0&id=e9dfc8a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9dfc8a6"]])

export default __exports__